import { state_ctrl_factory_method } from 'ww2_analytics/common/state_ctrl';

const main_view = {
    template: require('./view.html'),
    controller: state_ctrl_factory_method('purchases.video_revenue', function($scope, resp) {
        $scope.rows = resp;
    }),
};
const state_config = {
    url: '/video_revenue',
    reloadOnSearch: false,
    data: {
        priority: 801,
        title: 'Video Revenue',
    },
    views: {
        '': main_view,
    },
};
export default state_config;
